module.exports = __webpack_public_path__ + "img/deadline.ac33fa64.png";